import React, { useEffect, useMemo } from 'react'
import { useSelector } from 'react-redux'
import { useLocation, useParams } from '@reach/router'
import { parse } from 'query-string'

import { Button } from '@refera/ui-web'

import { getBudgetByIdSelectorJS, getStepStatusLogSelector } from '_/modules/budget/selectors'
import { useBudgetForm } from '_/views/budget-view-v2/hooks/use-budget-form'

import { useToast } from '_/hooks/use-toast'
import useRolePermission from '_/hooks/use-role-permission'

import { BUTTONS_ACTION } from '_/utils/constants/service-order'
import { PERMISSIONS, PERMISSIONS_ACTIONS } from '_/utils/constants/permissions'
import { CanDoButtonAction } from '_/utils/can-do-button-action'
import { getButtonsActionSelector } from '_/modules/service-orders/selectors'

export default function EditButton() {
  const { budgetId } = useParams()
  const { showToast } = useToast()
  const { isEditing, setIsEditing } = useBudgetForm()
  const { isAdmin, isTradesman, isAdminSAAS, checkUserPermission } = useRolePermission()
  const budget = useSelector(getBudgetByIdSelectorJS(budgetId))
  const { search } = useLocation()
  const { edit = false } = parse(search)

  // remove this section when add_internal_budget button action is created
  const stepStatusLog = useSelector(getStepStatusLogSelector)
  const buttonsAction = useSelector(getButtonsActionSelector)
  const hasSomeBudgetInStepLog = useMemo(
    () => stepStatusLog.some(log => log.budgetId?.toString() === budgetId),
    [stepStatusLog, budgetId]
  )
  const canReferaEdit = isAdmin && !hasSomeBudgetInStepLog
  // end

  const showButton = useMemo(() => {
    if (!budget?.isOriginal && budgetId && !isEditing) {
      if (isTradesman && budget?.released) return false
      return true
    }
    return false
  }, [isEditing, isTradesman, budget, budgetId])

  const buttonAction = isTradesman
    ? BUTTONS_ACTION.EDIT_BUDGET_BY_PROVIDER
    : BUTTONS_ACTION.EDIT_BUDGET

  const canEditBudget = CanDoButtonAction({
    nameButton: buttonAction,
  })

  useEffect(() => {
    if (edit) {
      toggleEdit()
    } else {
      setIsEditing(false)
    }
  }, [edit])

  function toggleEdit() {
    if (Boolean(buttonsAction) && canEditBudget === false && canReferaEdit === false) {
      showToast({
        type: 'error',
        message: 'Este orçamento está em uma etapa que não permite edição.',
      })
      return
    }

    if (isAdminSAAS) {
      setIsEditing(prev => (edit ? true : !prev))
      return
    }

    checkUserPermission({
      permission: PERMISSIONS.BUDGETS,
      permissionAction: PERMISSIONS_ACTIONS.ADD,
      functionAccess: () => setIsEditing(prev => (edit ? true : !prev)),
    })
  }

  if (!showButton) return null

  return (
    showButton && (
      <Button onClick={toggleEdit} color="primary" variant="secondary">
        Editar
      </Button>
    )
  )
}
